<div style="text-align: center;" *ngIf="!this.caseData">

  <div style="margin-top: 20px; width: 250px; margin-left: auto; margin-right: auto;">
    Please enter either<br /><br />
    <div style="text-align: left;">
      - the case number<br />
      - the case reference number<br />
      - the customer reference number<br />
    </div>
    <br />
    to open the customer data.
  </div>

  <div style="margin-top: 20px;">

    <mat-form-field class="search-field">
      <input #caseNumberField matInput (keydown.enter)="openCase()" placeholder="Input"
             [(ngModel)]="caseNumber" />
    </mat-form-field>
    <button [disabled]="isBusy" [class.spinner]="isBusy" style="margin-left: 10px;"  mat-raised-button color="primary" (click)="openCase()">Open</button>
  </div>


  <div style="margin-top: 30px; font-size: .8em;">
    Case access will be logged.
  </div>

</div>


<div *ngIf="this.caseData">

      <div style="margin-bottom: 10px;">

        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="mat-form-fullwidth">

          <div fxFlex="100" >
            <mat-card class="content-card">
              <mat-card-content>
                <button mat-button (click)="downloadPdf()">
                  <mat-icon>cloud_download</mat-icon> PDF
                </button>
                <button mat-icon-button (click)="closeCase()">
                  <mat-icon>arrow_back</mat-icon>
                </button>
              </mat-card-content>
            </mat-card>

          </div>
        </div>

        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="mat-form-fullwidth">

          <div fxFlex="50">

            <div>
              <mat-card class="content-card">
                <mat-card-header>

                  <mat-card-title-group>
                    <mat-card-title>
                      <h5>Customer</h5>
                    </mat-card-title>
                  </mat-card-title-group>
                  <div fxFlex></div>
                  <div fxLayoutAlign="center center">

                  </div>

                </mat-card-header>

                <mat-card-actions align="end">

                </mat-card-actions>

                <mat-card-content>

                  <!-- warnings -->
                  <div *ngIf="customer" style="margin-left: 10px;">
                    <div *ngIf="customer.identStatus == identStatus.fail" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                      <mat-icon style="color: white">beenhere</mat-icon> Ident failed!
                    </div>
                    <div *ngIf="customer.pepStatus == pepStatus.possibleMatch" style="border-radius: 4px; background-color: #ff9900; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                      <mat-icon style="color: white">perm_identity</mat-icon> Possible PEP match!
                    </div>
                    <div *ngIf="customer.pepStatus == pepStatus.confirmedMatch" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                      <mat-icon style="color: white">perm_identity</mat-icon> Confirmed PEP match!
                    </div>
                  </div>



                  <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
                    <app-content-row [field]="field" [entity]="customer"></app-content-row>
                  </div>

                  <div class="list-item" fxLayout="row">
                    <label fxFlex="35" class="secondary">Ident Level</label>
                    <label [fxFlex]="32" *ngIf="customer">

                    </label>
                    <label [fxFlex]="33" *ngIf="customer" style="text-align: right;">

                    </label>
                  </div>

                  <div class="list-item" fxLayout="row">
                    <label fxFlex="35" class="secondary">Address Status</label>
                    <label [fxFlex]="32" *ngIf="customer">

                    </label>
                    <label [fxFlex]="33" *ngIf="customer" style="text-align: right;">

                    </label>
                  </div>


                  <!--<button mat-raised-button style="margin-right: 5rem;" color="primary" *ngIf="customer && currentUserIsAdminOrCompliance()" [disabled]="!currentUserIsAdminOrCompliance()" (click)="createInternalDocsLink(customer)">Upload Docs</button>-->

                  <!--<a mat-raised-button color="primary" (click)="returnBack()">Back</a>-->
                  <!--<a mat-raised-button color="primary" routerLink="edit" *ngIf="editEnabled()">Edit</a>-->


                </mat-card-content>



              </mat-card>


            </div>

            <mat-card class="content-card" *ngIf="addressUploadFiles.length > 0">
              <mat-card-header>
                <mat-card-title>
                  <h5>Address documents</h5>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
                  <tr>
                    <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
                    <th style="text-align: left; width: 120px;"><label>Type</label></th>
                    <th style="text-align: left; width: 120px;"><label>Doc Type</label></th>
                    <th style="text-align: left"><label>File</label></th>
                    <th style="text-align: left"><label>Status</label></th>
                  </tr>
                  <tr *ngFor="let f of addressUploadFiles">
                    <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
                    <td><label>{{f.typName}}</label></td>
                    <td><label>{{f.docType}}</label></td>
                    <td>
                      <label *ngIf="currentUserIsAdminOrCompliance()">
                        <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                      </label>
                      <label *ngIf="!currentUserIsAdminOrCompliance()">
                        {{ f.originalFileName }}
                      </label>
                    </td>
                    <td>
                      <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                      <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                      <label *ngIf="f.isSuccess == null">-</label>
                    </td>
                  </tr>
                </table>
                <!--
                <hr *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived"  />
                <div *ngIf="docInvoice != null && !isDocsResendHidden  && !customer?.archived" style="margin-top: 10px;">
                  {{ docInvoice?.code }} - € {{docInvoice.billAmount}} / paid: € {{ docInvoice.paidAmount }}<br /><br />
                  <button mat-raised-button class="mr-4" color="accent" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsLink(customer)">resend Doc Link</button>
                  <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsDisabled(customer) || isDocsResendHidden || !docInvoice || docInvoice?.billAmount <= docInvoice?.paidAmount" (click)="resendDocsPaymentLink(customer)">resend payment link</button>
                  <button mat-raised-button class="mr-4" color="primary" [disabled]="isDocsResendUploadLinkDisabled" (click)="resendDocsInvoice(customer)">send Invoice</button>
                </div>
                -->

              </mat-card-content>
            </mat-card>

            <mat-card class="content-card">
              <mat-card-header>
                <mat-card-title>
                  <h5>🪪 Ident Document</h5>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>

                <ng-container *ngIf="isLoadingCustomer">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </ng-container>

                <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
                  <label fxFlex="20" class="secondary">Document</label>
                  <label fxFlex="10" class="secondary">Expiry</label>
                  <label fxFlex="35" class="secondary">Name</label>
                  <label fxFlex="15" class="secondary">DOB</label>
                </div>

                <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngIf="customer">
                  <label class="" fxFlex="20" >
                    <div>
                      {{ getIdentDocumentType(customer.identDocumentType) }}
                    </div>
                    <div>
                <span *ngIf="customer.identDocumentCountry">
                  <flag-icon country="{{ customer.identDocumentCountry.toLowerCase() }}"></flag-icon>
                </span> {{ customer.identDocumentNumber }}
                    </div>
                  </label>
                  <label class="" fxFlex="10" >
                    <ng-container *ngIf="customer.identValidUntilDate else noValidUntil">{{ customer.identValidUntilDate | date: "dd.MM.yyyy" }}</ng-container>
                    <ng-template #noValidUntil><i>unknown</i></ng-template>
                  </label>
                  <label class="" fxFlex="35" >
                    {{ customer.identDocumentFirstName }} {{ customer.identDocumentLastName }}
                  </label>
                  <label class="" fxFlex="15" >
                    {{ customer.identDocumentDob | date: "dd.MM.yyyy" }}
                  </label>

                </div>
              </mat-card-content>
              <mat-card-actions align="end">
                <div style="padding-right: 10px;">

                </div>
              </mat-card-actions>
            </mat-card>


            <mat-card class="content-card">
              <mat-card-header>
                <mat-card-title>
                  <h5>🛂 Ident Log</h5>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>

                <ng-container *ngIf="isLoadingIdentLog">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </ng-container>

                <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
                  <label fxFlex="20" class="secondary">Date</label>
                  <label fxFlex="15" class="secondary">Status</label>
                  <label fxFlex="5" class="secondary"></label>
                  <label fxFlex="15" class="secondary">Document</label>
                  <label fxFlex="10" class="secondary">Doc Expiry</label>
                </div>
                <div id="scroll">
                  <div class="list-item" fxLayout="row" fxLayoutGap="10px" *ngFor="let ident of idents" >
                    <label class="" fxFlex="20" >{{ ident.creationDate | date: "dd.MM.yyyy HH:mm" }}</label>
                    <label class="" fxFlex="15" >{{ getIdentStatusString1(ident.status) }}</label>
                    <label class="" fxFlex="5" >
                <span *ngIf="ident.documentCountry">
                  <flag-icon country="{{ ident.documentCountry.toLowerCase() }}"></flag-icon>
                </span>
                    </label>
                    <label class="" fxFlex="15" >
                      Type: {{ ident.documentType }}<br />Nr.: {{ ident.documentNumber }}
                    </label>
                    <label class="" fxFlex="10" >
                      <ng-container *ngIf="ident.documentValidUntil else noValidUntil">{{ ident.documentValidUntil | date: "dd.MM.yyyy" }}</ng-container>
                      <ng-template #noValidUntil><i>unknown</i></ng-template>
                    </label>
                  </div>
                </div>

              </mat-card-content>
            </mat-card>





            <mat-card class="content-card">
              <mat-card-header>
                <mat-card-title>
                  <h5>📑 All Documents</h5>
                </mat-card-title>
                <div fxFlex></div>


              </mat-card-header>
              <mat-card-content>
                <ng-container *ngIf="isLoadingAllDocuments">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </ng-container>

                <table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">
                  <tr>
                    <th class="" style="text-align: left; width: 150px;"><label>Date</label></th>
                    <th style="text-align: left; width: 120px;"><label>Type</label></th>
                    <th style="text-align: left; width: 120px;"><label>Doc Type</label></th>
                    <th style="text-align: left"><label>File</label></th>
                    <th style="text-align: left"><label>Status</label></th>
                  </tr>
                  <tr *ngFor="let f of allDocuments">
                    <td class=""><label>{{ f.uploadDate | date: "dd.MM.yyyy HH:mm" }}</label></td>
                    <td><label>{{f.typName}}</label></td>
                    <td><label>{{f.docType}}</label></td>
                    <td>
                      <label >
                        <a style="cursor: pointer; text-decoration: underline;" (click)="downloadFile(f.id)">{{ f.originalFileName }}</a>
                      </label>
                      <label >
                        {{ f.originalFileName }}
                      </label>
                    </td>
                    <td>
                      <label *ngIf="f.isSuccess == true" style="color: green;">Success</label>
                      <label *ngIf="f.isSuccess == false" style="color: red;">Failed</label>
                      <label *ngIf="f.isSuccess == null">-</label>
                    </td>
                  </tr>
                </table>

              </mat-card-content>
            </mat-card>










          </div>


          <div fxFlex="50">


            <mat-card class="content-card">
              <mat-card-header>
                <mat-card-title>
                  <h5>💳 Cards</h5>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>

                <mat-accordion class="">
                  <mat-expansion-panel disabled=true>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div style="width: 200px;">
                        Card
                        </div>
                      </mat-panel-title>
                      <mat-panel-title>
                        Token
                      </mat-panel-title>
                      <mat-panel-title>
                        Expiry date
                      </mat-panel-title>
                      <mat-panel-title>
                        Status
                      </mat-panel-title>
                      <!--<mat-panel-title>
                        Last Payment Reminder
                      </mat-panel-title>-->
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
                  <mat-expansion-panel *ngFor="let card of cards">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <div style="width: 200px;">
                        {{card.productShortName}}
                        </div>
                      </mat-panel-title>
                      <mat-panel-title>
                        {{card.token}}
                      </mat-panel-title>
                      <mat-panel-title>
                        {{card.expireDate | date: 'MM/yy'}}
                      </mat-panel-title>
                      <mat-panel-title class=" {{card.status == 6 ? 'warning-row' : ''}}">
                        {{card.statusName}}<div style="display: inline-block; margin-left: 4px; padding: 3px; background-color: dodgerblue; color: black; font-size: .8em;" *ngIf="card.reorderReason">R</div>
                      </mat-panel-title>

                    </mat-expansion-panel-header>

                    <div class="list-item" fxLayout="row" *ngFor="let field of cardFields">
                      <app-content-row [field]="field" [entity]="card"></app-content-row>


                      <div *ngIf="card.reorderReason" style="margin: 5px; padding: 5px; border-radius: 5px; background-color: dodgerblue">
                        <b>This card has been re-ordered</b><br />
                        <hr style="border-top: 1px solid black; border-bottom: none;" />
                        <div *ngIf="card.reorderReason === cardReorderReason.LostOrStolen">Lost or stolen</div>
                        <div *ngIf="card.reorderReason === cardReorderReason.CardNotArrived">Card not arrived</div>
                        <div *ngIf="card.reorderReason === cardReorderReason.Expired">Expired</div>
                        Comment: <i>{{ card.reorderComment }}</i>
                      </div>
                    </div>


                    <div *ngIf="card.transactions" style="margin-top: 10px;" class="statement">
                      <h4>Statement - last 2 years</h4>
                      <table mat-table matSort [dataSource]="card.transactions" class="mat-elevation-z8" style="width: 100%;">

                        <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->

                        <ng-container matColumnDef="direction">
                          <th mat-header-cell *matHeaderCellDef style="width: 25px;"></th>
                          <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.type === 'A' && element.statusCode === 'A'">⌛️</ng-container>
                            <ng-container *ngIf="element.type === 'D' && element.statusCode === 'A'">↩️️</ng-container>
                            <ng-container *ngIf="element.type === 'L'">💰</ng-container>
                            <ng-container *ngIf="element.type === 'U'">💸</ng-container>
                            <ng-container *ngIf="element.type === 'P' && element.statusCode === 'S'">✅</ng-container>
                            <ng-container *ngIf="element.type === 'B' && element.isCredit">🔼</ng-container>
                            <ng-container *ngIf="element.type === 'B' && !element.isCredit">🔽</ng-container>
                            <ng-container *ngIf="element.statusCode === 'I'">⛔️</ng-container>

                          </td>
                        </ng-container>

                        <ng-container matColumnDef="transactionDate">
                          <th mat-header-cell *matHeaderCellDef style="width: 100px;">Date</th>
                          <td mat-cell *matCellDef="let element"> {{ element.transactionDate | date:'dd.MM.yyyy'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="description">
                          <th mat-header-cell *matHeaderCellDef style=""> Description </th>
                          <td mat-cell *matCellDef="let element">
                            <div class="txn-description">{{element.description}}</div>
                            <div *ngIf="element.note" style="font-size: .9em; font-family: monospace;" [class]="'statement-note-' + element.statusCode">
                              📝 {{element.note}}
                            </div>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="amount">
                          <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Amt. </th>
                          <td mat-cell *matCellDef="let element" style="text-align: right;">
                            <div [class]="'amount-' + element.statusCode">
                              {{element.amount.toFixed(2)}}
                            </div>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="blockAmount">
                          <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Blk. </th>
                          <td mat-cell *matCellDef="let element" style="text-align: right;">
                            <ng-container *ngIf="element.blockedAmount">
                              {{element.blockedAmount.toFixed(2)}}
                            </ng-container>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="billAmount">
                          <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Bill </th>
                          <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.billAmount.toFixed(2)}} </td>
                        </ng-container>

                        <ng-container matColumnDef="currency">
                          <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: center;"> Cur. </th>
                          <td mat-cell *matCellDef="let element" style=" text-align: center;"> {{element.currency}} </td>
                        </ng-container>

                        <ng-container matColumnDef="rateFee">
                          <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Rate f. </th>
                          <td mat-cell *matCellDef="let element" style="text-align: right;">
                            <ng-container *ngIf="element.rateFee">
                              {{element.rateFee.toFixed(2)}}
                            </ng-container>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="fixedFee">
                          <th mat-header-cell *matHeaderCellDef style="width: 45px; text-align: right;"> Fixed f. </th>
                          <td mat-cell *matCellDef="let element" style="text-align: right;">
                            <ng-container *ngIf="element.fixedFee">
                              {{element.fixedFee.toFixed(2)}}
                            </ng-container>
                          </td>
                        </ng-container>


                        <ng-container matColumnDef="statusDescription">
                          <th mat-header-cell *matHeaderCellDef style="width: 80px;  text-align: center;"> Status </th>
                          <td mat-cell *matCellDef="let element" style=" text-align: right;">
                            <div [class]="'status-' + element.statusCode">
                              {{ element.statusDescription }}
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedStatementColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedStatementColumns;" class="txn-row"></tr>
                      </table>
                    </div>



                    <mat-card-actions align="end" >

                    </mat-card-actions>




                  </mat-expansion-panel>
                </mat-accordion>

              </mat-card-content>
            </mat-card>








            <mat-card class="content-card">
              <mat-card-header>
                <mat-card-title>
                  <h5>📄 Orders</h5>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>

                <div class="list-item">
            <span fxFlex="25" *ngFor="let field of ordersFields">
                <label *ngIf="orders" class="secondary" >{{field.header}}</label>

            </span>
                  <span>&nbsp;</span>
                </div>
                <div class="" fxLayout="row" *ngFor="let order of orders; let i = index">
                  <mat-expansion-panel fxFlex="100" >
                    <mat-expansion-panel-header class="">
                <span fxFlex="25" *ngFor="let field of ordersFields" >
                  <label class="{{ order.archived ? 'archived ': ''}}{{(order.status == 4 && field.header == 'Status' ) ? 'warning-row' : ''}}" *ngIf="field.type !== 'button'">{{field.cell(order)}}</label>


                </span>
                    </mat-expansion-panel-header>



                    <div class="list-item">
                      <span class="mr-2" *ngIf="!order">Order not exist/or has been removed</span>


                      <div class="text-right">

                      </div>





                      <div *ngIf="order">

                        <div class="text-right mt-2 mb-2">

                        </div>

                        <!-- #region reorder details -->
                        <ng-container *ngIf="order && order.isReorderOrder">

                          <div style="background-color: lightskyblue; padding: 0 5px">
                            <h5>Re-Order</h5>
                          </div>

                        </ng-container>
                        <!-- #region reorder details -->

                        <ng-container *ngIf="order.loadAmount > 0">
                          <div style="background-color: dodgerblue; padding: 0 5px">
                            Card will be created with balance {{ order.loadAmount | number : '1.2-2' }}
                          </div>
                        </ng-container>


                        <table  class="list-table">

                          <tr>
                            <td class="secondary">ExternalRef</td>
                            <td><label>{{ order.externalRef }}</label></td>
                          </tr>
                          <tr>
                            <td class="secondary">Card Name</td>
                            <td><label>{{ order.cardName }}</label></td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              <mat-expansion-panel class="" *ngIf="order.invoice">
                                <mat-expansion-panel-header>
                          <span class="{{ order.invoice.archived ? 'archived ': ''}}">
                            Invoice {{ order.invoice.code }}
                          </span>
                                </mat-expansion-panel-header>

                              </mat-expansion-panel>
                            </td>
                          </tr>
                          <tr>
                            <td class="secondary">Partner Customer ID</td>
                            <td>
                              <label>
                                {{ order.partnerCustomerId }}
                              </label>
                            </td>
                          </tr>

                          <tr *ngFor="let field of ordersFields2">
                            <td class="secondary">{{ field.header }}</td>
                            <td *ngIf="order"><label>{{ field.cell(order) }}</label></td>

                          </tr>


                          <ng-container *ngIf="order.webIdTransaction">
                            <tr>
                              <td class="secondary">Ident type</td>
                              <td>
                                <label *ngIf="order.webIdTransaction.providerCode == 0">
                                  WebID
                                </label>
                                <label *ngIf="order.webIdTransaction.providerCode == 1">
                                  Onfido
                                </label>
                                <label *ngIf="order.webIdTransaction.providerCode == 2">
                                  Veriff
                                </label>
                              </td>
                            </tr>
                          </ng-container>


                          <ng-container *ngIf="order && order.cancellationReason != null">
                            <tr *ngFor="let field of cancellationFields">
                              <td class="secondary"><label>{{ field.header }}</label></td>
                              <td *ngIf="order"><label>{{ field.cell(order) }}</label></td>
                            </tr>
                          </ng-container>

                          <ng-container *ngIf="order && order.userCancellationReasonName">
                            <tr *ngFor="let field of cancellationExtraFields">
                              <td class="secondary"><label>{{ field.header }}</label></td>
                              <td *ngIf="order"><label>{{ field.cell(order) }}</label></td>
                            </tr>
                          </ng-container>
                        </table>

                      </div>
                    </div>





                  </mat-expansion-panel>
                </div>
              </mat-card-content>

            </mat-card>





          </div>

        </div>
      </div>
</div>
